import { render, staticRenderFns } from "./daily-cargo-detail-table.vue?vue&type=template&id=2f2d4c1e"
import script from "./daily-cargo-detail-table.vue?vue&type=script&lang=js"
export * from "./daily-cargo-detail-table.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-detail-table.vue?vue&type=style&index=0&id=2f2d4c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports